import PropTypes from "prop-types";

/**
 * Table Header Shape
 * Shape for table column header configuration
 *
 * @typedef {Object} TableHeader
 * @property {string} key - Unique column identifier (required)
 * @property {string} label - Column header display text (required)
 * @property {boolean} [sortable] - Whether column can be sorted
 * @property {string} [width] - Column width (CSS value like '100px' or '20%')
 * @property {('left'|'center'|'right')} [align] - Text alignment within column cells
 */
export const tableHeaderShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  sortable: PropTypes.bool,
  width: PropTypes.string,
  align: PropTypes.oneOf(["left", "center", "right"]),
});

/**
 * Table Row Data Shape
 * Shape for generic table row data
 *
 * @typedef {Object} TableRow
 * @property {string|number} id - Unique row identifier (required)
 */
export const tableRowShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
});
